import React from 'react'
import GadgetStore from '../../../components /ProductPage/ItemsProduct/GadgetProduct'

const GadgetStorePage = () => {
  return (
    <div>
      <GadgetStore />
    </div>
  )
}

export default GadgetStorePage
